/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddUserToOrgRequest
 */
export interface AddUserToOrgRequest {
    /**
     * The ID of the builder to add to the organization
     * @type {string}
     * @memberof AddUserToOrgRequest
     */
    builderId: string;
}

/**
 * Check if a given object implements the AddUserToOrgRequest interface.
 */
export function instanceOfAddUserToOrgRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "builderId" in value;

    return isInstance;
}

export function AddUserToOrgRequestFromJSON(json: any): AddUserToOrgRequest {
    return AddUserToOrgRequestFromJSONTyped(json, false);
}

export function AddUserToOrgRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddUserToOrgRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'builderId': json['builderId'],
    };
}

export function AddUserToOrgRequestToJSON(value?: AddUserToOrgRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'builderId': value.builderId,
    };
}

